import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ClipboardListIcon, UsersIcon, StarIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <ClipboardListIcon className="w-8 h-8 text-amber-500" data-id="element-1015" />,
    title: 'Tell Us What You Need',
    description: 'Select your service type and describe your project. It only takes 60 seconds.',
    number: '1'
  }, {
    icon: <UsersIcon className="w-8 h-8 text-amber-500" data-id="element-1016" />,
    title: 'Get Matched with Pros',
    description: 'We connect you with up to 4 vetted, local professionals who are ready to help.',
    number: '2'
  }, {
    icon: <StarIcon className="w-8 h-8 text-amber-500" data-id="element-1017" />,
    title: 'Compare & Hire',
    description: 'Review quotes, check ratings, and choose the pro that fits your budget and timeline.',
    number: '3'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="how-it-works" className="py-20 bg-white" data-id="element-1018">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1019">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1020">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-1021">
            How It Works
          </h2>
          <p className="text-lg text-slate-600" data-id="element-1022">
            Get matched with the right pro in minutes
          </p>
        </div>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-1023">
          {steps.map((step, index) => <motion.div key={index} variants={itemVariants} className="relative flex flex-col items-center text-center" data-id="element-1024">
              <div className="w-20 h-20 rounded-2xl bg-amber-50 flex items-center justify-center mb-6 relative" data-id="element-1025">
                {step.icon}
                <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-amber-500 text-white font-bold flex items-center justify-center border-4 border-white shadow-sm" data-id="element-1026">
                  {step.number}
                </div>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-1027">
                {step.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-1028">
                {step.description}
              </p>

              {/* Connector line for desktop */}
              {index < steps.length - 1 && <div className="hidden md:block absolute top-10 left-[60%] w-[80%] h-[2px] bg-slate-100 -z-10" data-id="element-1029" />}
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}